import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageLoading } from './appPage';

/** Full-app auth bootstrap loading (centered). */
const Loading = () => {
  const { t } = useTranslation();
  return (
    <div className="loading-screen">
      <PageLoading message={t('common.loading', 'Loading...')} />
    </div>
  );
};

export default Loading;
